module.exports = __webpack_public_path__ + "static/media/avatar.8b8efba7.png";